import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { EnvService, TtHttpClientService } from 'app/core/services';

@Injectable({ providedIn: 'root' })
export class LicenseService {
  private licenses: Record<string, string> = {};

  constructor(
    private readonly http: TtHttpClientService,
    private readonly envService: EnvService
  ) {}

  async load(): Promise<void> {
    const keys = ['nutrient-web-sdk-license-key'];
    const requests = keys.map(key => firstValueFrom(this.http.get<{ key: string; value: string }>(this.envService.api.secrets.getSecret(key))));

    const results = await Promise.all(requests);

    for (const res of results) {
      if (res?.key && res?.value) {
        this.licenses[res.key] = res.value;
      }
    }
  }

  get(key: string): string | null {
    return this.licenses[key] || null;
  }
}
